import { useEffect, useState } from 'react';
import Moment from 'react-moment';
import '../filter/styles.scss';
import Loading from '../../../common/loading';
import Table from '../../../common/table';
import l from '../../../../lang';
import '../styles.scss';
import { createDate } from '../../../../utils';
import TopDashboardSection from '../../../common/top-dashboard-section';
import Card from '../../../common/card';
import CardDescription from '../../../common/card-description';
import { Empty, EmptyNoFound } from '../empty';
import { useTransactions } from '../../../../store/transactions';
import { Filters } from '../../../../store/interfaces';
import AlertMessages from '../../alert-messages';
import DateRangePicker from '../../../common/date-range-picker';
import moment from 'moment';
import { useDashboard } from '../../../../store/dashboard';

const TransactionsStatement = () => {
  const { loading, error, getTransactionStatementData, transactionStatementData } = useTransactions();

  const initFilters = {
    start_date: moment().startOf('month').format('YYYY-MM-DD'),
    end_date: moment().format('YYYY-MM-DD'),
  };
  const [filter, setFilter] = useState<Filters>(initFilters);
  const { merchantMe } = useDashboard();

  useEffect(() => {
    getTransactionStatementData(0, filter);
  }, [filter]);

  const hasFilter = Object.values(filter).some(value => value !== '');
  const hasTransactions = transactionStatementData && transactionStatementData?.operations?.length > 0;

  const EmptyBody = () => {
    if (!error && !hasTransactions && !hasFilter) {
      return <Empty />;
    }
    if (error || !hasTransactions) {
      return <EmptyNoFound />;
    }
    return null;
  };

  return (
    <div className="transactions">
      <TopDashboardSection title={l('transactions_statement.title')} />
      <AlertMessages />
      <Card>
        <CardDescription>
          <div className="transactions_header">
            <span>{l('transactions_statement.subheadline')}</span>
          </div>
        </CardDescription>
        <div className="transactions__content">
          <div className="transactions__filter_wrapper">
            <div className="transaction_filter">
              <DateRangePicker
                fromDate={filter.start_date}
                toDate={filter.end_date}
                changeFrom={filters => setFilter({ ...filter, start_date: filters })}
                changeTo={filters => setFilter({ ...filter, end_date: filters })}
              />
            </div>
          </div>
          {loading && (
            <div className="transactions__loading">
              <Loading />
            </div>
          )}
          {!loading && (
            <div className="transactions__table">
              <div className="transactions_statement_header">
                <h3>
                  {l(
                    'transactions_statement.header',
                    moment(filter.start_date).format('YYYY/MM/DD'),
                    moment(filter.end_date).format('YYYY/MM/DD')
                  )}
                </h3>
                <div className="transactions_statement_header__columns">
                  <div className="transactions_statement_header__column">
                    <div>
                      <span>{l('transactions_statement.totalTransactions')}:</span> {merchantMe?.functionalCurrency}{' '}
                      {transactionStatementData?.transactionsTotal}
                    </div>
                    <div>
                      <span>{l('transactions_statement.totalCbksRefunds')}:</span> {merchantMe?.functionalCurrency}{' '}
                      {transactionStatementData?.refundChargebackTotal}
                    </div>
                  </div>
                  <div className="transactions_statement_header__column">
                    <div>
                      <span>{l('transactions_statement.totalSettlements')}:</span> {merchantMe?.functionalCurrency}{' '}
                      {transactionStatementData?.settlementsTotal}
                    </div>
                    <div>
                      <span>{l('transactions_statement.totalCredits')}:</span> {merchantMe?.functionalCurrency}{' '}
                      {transactionStatementData?.netCreditsTotal}
                    </div>
                  </div>
                </div>
              </div>
              <Table
                emptyBody={<EmptyBody />}
                headers={[
                  <span className="transactions__column__left">{l('transactions_statement.datetime')}</span>,
                  <span className="transactions__column__left">{l('transactions_statement.operation')}</span>,
                  <span className="transactions__column__left">{l('transactions_statement.identifier')}</span>,
                  <span className="transactions__column__left">{l('transactions_statement.credit')}</span>,
                  <span className="transactions__column__left">{l('transactions_statement.debit')}</span>,
                ]}
                body={
                  (hasTransactions &&
                    !error &&
                    transactionStatementData?.operations?.map(trans => {
                      return [
                        <span className="transactions__column__left">
                          <Moment format="DD/MM/YYYY HH:mm:ss">{createDate(trans.date)}</Moment>
                        </span>,
                        <span className="transactions__column__left transactions__column__invoice">
                          <span>{trans.operation}</span>
                        </span>,
                        <span className="transactions__column__left">{trans.identifier}</span>,
                        <span className="transactions__column__left">
                          {trans.amount > 0 ? `${merchantMe?.functionalCurrency} ${trans.amount}` : ''}
                        </span>,
                        <span>{trans.amount < 0 ? `${merchantMe?.functionalCurrency} ${Math.abs(trans.amount)}` : ''}</span>,
                      ];
                    })) ||
                  null
                }
                rowsPerPageOptions={[transactionStatementData?.size]}
                rowsLength={transactionStatementData?.totalElements}
                rowsPerPage={transactionStatementData?.size}
                page={transactionStatementData?.page}
                handleChangePage={(event, newPage) => {
                  getTransactionStatementData(newPage, filter);
                }}
              />
            </div>
          )}
        </div>
      </Card>
    </div>
  );
};

export default TransactionsStatement;
